import { SET_ANSWER } from "../actions/types";

const INITIAL_STATE = {};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_ANSWER:
      //console.log("Respuesta Reducer Answer", action);
      return { ...action.payload.Result };
    default:
      return state;
  }
};
